document.addEventListener("DOMContentLoaded", function () {
    const mainProductImage = document.querySelector('#mainProductImage');
    const colorPanel = document.querySelector('.collapsible-container[data-name="color"]');
    const colorSwatchesContainer = colorPanel.querySelector('.accordion-color-container');
    const selectedCoffeeMaker = document.querySelector('#selectedCoffeeMaker');
    const selectedCoffeeMakerDesc = document.querySelector('#selectedCoffeeMakerDesc');
    const titleAccessory_1 = document.querySelector('.collapsible-container[data-name="accessory_1"] .accordion-title');
    const titleAccessory_2 = document.querySelector('.collapsible-container[data-name="accessory_2"] .accordion-title');
    const titleCoffee = document.querySelector('.collapsible-container[data-name="coffee"] .accordion-title');
    const selectedAccessory_1 = document.querySelector('#selectedAccessory_1');
    const selectedAccessory_2 = document.querySelector('#selectedAccessory_2');
    const selectedCoffee = document.querySelector('#selectedCoffee');
    let selectedAccessoryId = null;
    var currentAccessoriesCollection = Object.values(accessories_collections[0])[0];
    var currentNovelId = Object.values(novel_ids[0])[0];
    //const selectedCoffeeDesc = document.querySelector('#selectedCoffeeDesc');
    const selectedColor = document.querySelector('#selectedColor');
    const removeButtons = document.querySelectorAll('button[data-btn-remove]');
    const skipButtons = document.querySelectorAll('button[data-btn-skip]');
    const atcBtn = document.querySelectorAll('[data-btn-atc]');
    const chkAeropress = document.querySelector('#chkAeropress');
    const chkWholeBean = document.querySelector('#chkAeropress');
    const radAeropress = document.querySelector('#radAeropress');
    const radWholeBean = document.querySelector('#radWholeBean');
    const itemsCount = document.querySelector('#itemsCount');
    const sectionSummary = document.querySelector('.section-summary');
    const mobileSection = document.querySelector('.section-summary mobile-section');
    const mobileOgTotal = mobileSection.querySelector('.orig-total');
    const mobileGTotal = mobileSection.querySelector('.grand-total');
    const mobileDiscount = mobileSection.querySelector('.total-discount');
    const bundleProgress = document.querySelector('#bundleProgress');
    const stickyAtcButton = document.querySelector(".section-summary button[data-btn-atc]");
    const stampedMainWidget = document.getElementById("stamped-main-widget");
    const confirmCoffeeMaker = document.querySelector('.collapsible-container[data-name=coffee-maker] button[data-btn-confirm]');
    const collapsibleColor = document.querySelector('.collapsible-container[data-name=color]');
    const collapsibleAccessory_1 = document.querySelector('.collapsible-container[data-name=accessory_1]');
    const collapsibleAccessory_2 = document.querySelector('.collapsible-container[data-name=accessory_2]');
    const collapsibleCoffee = document.querySelector('.collapsible-container[data-name=coffee]');
    const progressBar = document.querySelector('#bundleProgress .progress-bar__fill');
    const bundleObj = {
        coffeeMaker: null,
        color: null,
        accessory_1: null,
        accessory_2: null,
        coffee: null
    };
    var checkoutURL = '';

    const notyf = new Notyf({
        duration: 4000,
        position: { x: 'center', y: 'bottom' },
         types: [
            {
                type: 'success',
                background: '#383738',
            },
            {
                type: 'error',
                background: 'indianred',
                duration: 2000,
                dismissible: true
            }
        ]
    });

    async function getProductVariants(handle) {
        try {
            // Fetch product JSON by handle
            const res = await fetch(`/products/${handle}.js`);
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

            const product = await res.json();

            // Variants are in product.variants
            return product.variants.map(variant => ({
                id: variant.id,
                title: variant.title,
                sku: variant.sku,
                price: variant.price, // in cents
                available: variant.available,
                options: variant.options, // array of option values
                featured_image: variant.featured_image?.src || null
            }));
        } catch (err) {
            console.error("Error fetching product variants:", err);
            return [];
        }
    }
    
    async function getProductColors(handle) {
        try {
            // Find the entry that contains this handle
            const entry = color_swatches.find(obj => obj[handle]);

            // Return the whole swatch array or [] if not found
            return entry ? entry[handle] : [];
        } catch (err) {
            console.error("Error getting product colors:", err);
            return [];
        }
    }

    function updateSummary() {
        const summary = document.getElementById("bundleSummary");
        if (!summary) return;

        function parsePrice(priceStr) {
            return priceStr ? parseFloat(priceStr.replace(/[^0-9.]/g, "")) : 0;
        }

        const items = [
            bundleObj.coffeeMaker,
            bundleObj.accessory_1,
            bundleObj.accessory_2,
            bundleObj.coffee,
        ];

        let originalTotal = 0;
        let itemCount = 0;

        // Subtotals
        let coffeeMakerTotal = 0;
        let extrasTotal = 0;

        items.forEach((item) => {
            if (item?.price) {
                const price = parsePrice(item.price);
                originalTotal += price;
                itemCount++;

                if (item === bundleObj.coffeeMaker) {
                    coffeeMakerTotal += price;
                } else {
                    extrasTotal += price;
                }
            }
        });

        if (itemCount > 0) {
            sectionSummary.removeAttribute("hidden");
        } else {
            sectionSummary.setAttribute("hidden", "");
        }

        let discountRate = 0;
        const hasCoffeeMaker = !!bundleObj.coffeeMaker;

        if (hasCoffeeMaker) {
            const extras = [
                bundleObj.accessory_1,
                bundleObj.accessory_2,
                bundleObj.coffee,
            ].filter(Boolean).length;

            if (extras === 1) {
                discountRate = 0.10;
            } else if (extras === 2) {
                discountRate = 0.15;
            } else if (extras === 3) {
                discountRate = 0.20;
            }
        }

        // Apply discount only on extras
        const discount = extrasTotal * discountRate;
        const total = coffeeMakerTotal + (extrasTotal - discount);

        let discountLabel = "";
        if (discountRate > 0) {
            discountLabel = `Bundle Discount - ${discountRate * 100}% off accessories & coffee`;
        }

        summary.innerHTML = `
            <table class="bundle-summary">
            <tbody>
                <tr>
                <td>
                    ${bundleObj.coffeeMaker?.title || ""}
                    ${bundleObj.color?.name ? ` - ${bundleObj.color.name}` : ""}
                </td>
                <td>${formatPrice(bundleObj.coffeeMaker?.price, bundleObj.coffeeMaker?.compare_price)}</td>
                </tr>
                <tr>
                <td>${bundleObj.accessory_1?.title || ""}</td>
                <td>${formatPrice(bundleObj.accessory_1?.price, bundleObj.accessory_1?.compare_price)}</td>
                </tr>
                <tr>
                <td>${bundleObj.accessory_2?.title || ""}</td>
                <td>${formatPrice(bundleObj.accessory_2?.price, bundleObj.accessory_2?.compare_price)}</td>
                </tr>
                <tr>
                <td>${bundleObj.coffee?.title || ""}</td>
                <td>${formatPrice(bundleObj.coffee?.price, bundleObj.coffee?.compare_price)}</td>
                </tr>
                <tr>
                <td>Shipping</td>
                <td style="text-align:right;">Free</td>
                </tr>
                ${discountRate > 0 ? `
                <tr class="discount-row">
                <td>${discountLabel}</td>
                <td style="text-align:right;">- $${discount.toFixed(2)}</td>
                </tr>` : ""}
                <tr class="total-row">
                <td><strong>Total</strong></td>
                <td style="text-align:right;">
                ${total.toFixed(2) !== originalTotal.toFixed(2) 
                    ? `<span class="orig-total">$${originalTotal.toFixed(2)}</span>` 
                    : ''}
                <span><strong>$${total.toFixed(2)}</strong></span>
                </td>
                </tr>
            </tbody>
            </table>
        `;

        // Mobile summary updates
        mobileOgTotal.innerText = originalTotal.toFixed(2) !== total.toFixed(2) 
            ? `$${originalTotal.toFixed(2)}` 
            : '';
        mobileGTotal.innerText = `$${total.toFixed(2)}`;
        mobileDiscount.innerText = discount > 0 ? `Save $${discount.toFixed(2)}` : '';             

        if (itemsCount) {
            itemsCount.textContent = `${itemCount} items`;
        }
        updateBundleProgress(bundleObj);

        checkoutURL = buildCheckoutURL(bundleObj);
        console.log(`checkoutURL: ${JSON.stringify(checkoutURL)}`);

        if (atcBtn && checkoutURL) {
            atcBtn.forEach(btn => {
                btn.addEventListener("click", () => {
                    window.location.href = checkoutURL;
                });
            });
        }
    }

    function buildCheckoutURL(bundleObj) {
        const shopUrl = window.Shopify?.routes?.root || "/"; // fallback if not defined
        const variants = [];

        // Always push the coffee maker (or selected color variant)
        if (bundleObj.coffeeMaker) {
            const coffeeMakerVariantId = bundleObj.color?.id || bundleObj.coffeeMaker.id;
            variants.push(`${coffeeMakerVariantId}:1`);
        }

        // Optional items
        if (bundleObj.accessory_1?.id) variants.push(`${bundleObj.accessory_1.id}:1`);
        if (bundleObj.accessory_2?.id) variants.push(`${bundleObj.accessory_2.id}:1`);
        if (bundleObj.coffee?.id) variants.push(`${bundleObj.coffee.id}:1`);

        // Figure out which discount code to apply
        let discountCode = "";
        const hasCoffeeMaker = !!bundleObj.coffeeMaker;
        if (hasCoffeeMaker) {
            const extras = [
                bundleObj.accessory_1,
                bundleObj.accessory_2,
                bundleObj.coffee,
            ].filter(Boolean).length;

            if (extras === 1) {
                discountCode = "BUNDLE10_HGQ481"; // Coffee maker + 1 extra
            } else if (extras === 2) {
                discountCode = "BUNDLE15_K47QQX"; // Coffee maker + 2 extras
            } else if (extras === 3) {
                discountCode = "BUNDLE20_Z5DWJS"; // Coffee maker + 2 extras + coffee
            }
        }

        // Join all variants and build final URL
        const variantString = variants.join(",");
        let checkoutURL = `${shopUrl}cart/${variantString}`;
        if (discountCode) {
            checkoutURL += `?discount=${discountCode}`;
        }

        return checkoutURL;
    }


    document.querySelectorAll("[data-btn-confirm]").forEach((btn) => {
        btn.addEventListener("click", function () {
            const section = this.closest("collapsible-content");
            const checked = section.querySelector('input[type=radio]:not([name="grindType"]):checked');
            const checkedGrindType = section.querySelector('input[name="grindType"]:checked');

            if (!checked) {
                notyf.error('Please select an option before continuing.');
                return;
            }

            const name = checked.name;
            const title = checked.dataset.title || checked.value;

            if (name === "coffee-maker") {
                bundleObj.coffeeMaker = { id: checked.value, title, price: checked.dataset.variantPrice, compare_price: checked.dataset.variantComparePrice };
                bundleObj.color = null;
                if(confirmCoffeeMaker.dataset.hasColor == 'true') {
                    collapsibleColor.querySelector('.collapsible-toggle').setAttribute('aria-expanded','true');
                    collapsibleColor.querySelector('collapsible-content').setAttribute('open','');
                    collapsibleAccessory_1.querySelector('.collapsible-toggle').setAttribute('aria-expanded','false');
                    collapsibleAccessory_1.querySelector('collapsible-content').removeAttribute('open');
                }
                else {
                    collapsibleColor.querySelector('.collapsible-toggle').setAttribute('aria-expanded','false');
                    collapsibleColor.querySelector('collapsible-content').removeAttribute('open');
                    collapsibleAccessory_1.querySelector('.collapsible-toggle').setAttribute('aria-expanded','true');
                    collapsibleAccessory_1.querySelector('collapsible-content').setAttribute('open','');
                }
            } 
            else if (name.includes("color")) {
                const coffeeMaker = document.querySelector('input[name="coffee-maker"]:checked');
                bundleObj.color = {
                    id: checked.dataset.variantId,
                    value: checked.value,
                    name: checked.dataset.name
                };
                if(!bundleObj.coffeeMaker) {
                    bundleObj.coffeeMaker = { id: coffeeMaker.value, title: coffeeMaker.dataset.title, price: coffeeMaker.dataset.variantPrice, compare_price: coffeeMaker.dataset.variantComparePrice };
                }
                collapsibleAccessory_1.querySelector('.collapsible-toggle').setAttribute('aria-expanded','true');
                collapsibleAccessory_1.querySelector('collapsible-content').setAttribute('open','');
                //Close:
                if(confirmCoffeeMaker.dataset.hasColor == 'true') {
                    collapsibleColor.querySelector('.collapsible-toggle').setAttribute('aria-expanded','false');
                    collapsibleColor.querySelector('collapsible-content').removeAttribute('open');
                }
            } 
            else if (name === "accessory_1") {
                bundleObj.accessory_1 = { id: checked.value, title, price: `$${checked.dataset.variantPrice}` };
                if(checked.dataset.variantComparePrice != '') {
                    bundleObj.accessory_1.compare_price = `$${checked.dataset.variantComparePrice}`;
                }
                collapsibleAccessory_2.querySelector('.collapsible-toggle').setAttribute('aria-expanded','true');
                collapsibleAccessory_2.querySelector('collapsible-content').setAttribute('open','');
                //Close:
                collapsibleAccessory_1.querySelector('.collapsible-toggle').setAttribute('aria-expanded','false');
                collapsibleAccessory_1.querySelector('collapsible-content').removeAttribute('open');
            }
            else if (name === "accessory_2") {
                bundleObj.accessory_2 = { id: checked.value, title, price: `$${checked.dataset.variantPrice}` };
                if(checked.dataset.variantComparePrice != '') {
                    bundleObj.accessory_2.compare_price = `$${checked.dataset.variantComparePrice}`;
                }
                collapsibleCoffee.querySelector('.collapsible-toggle').setAttribute('aria-expanded','true');
                collapsibleCoffee.querySelector('collapsible-content').setAttribute('open','');
                //Close:
                collapsibleAccessory_2.querySelector('.collapsible-toggle').setAttribute('aria-expanded','false');
                collapsibleAccessory_2.querySelector('collapsible-content').removeAttribute('open');
            }
            else if (name === "coffee") {
                bundleObj.coffee = { id: checkedGrindType.value || checked.value, title, price: checked.dataset.variantPrice, compare_price: checked.dataset.variantComparePrice };
                collapsibleAccessory_2.querySelector('.collapsible-toggle').setAttribute('aria-expanded','false');
                collapsibleAccessory_2.querySelector('collapsible-content').removeAttribute('open');
            }

            updateSummary();
            if (name.includes("color")) {
                notyf.success(`Color ${checked.dataset.name} selected.`);
            }
            else {
                notyf.success(`${title} added to your bundle.`);
            }
            updateSkipButtons();
        });
    });

    window.flickity.then((instances) => {
        const carouselEl = document.querySelector('[data-carousel="carousel-coffee"]');
        if (!carouselEl) return;

        const flkty = instances["carousel-coffee"];
        if (!flkty) return;

        let page = 2; // first batch already loaded in Liquid
        let loading = false;
        let hasMore = true;

        function loadMoreProducts() {
            if (loading || !hasMore) return;
            loading = true;

            fetch(`/collections/coffee/products.json?page=${page}`)
            .then((res) => res.json())
            .then((data) => {
                if (!data.products || data.products.length === 0) {
                    hasMore = false;
                    return;
                }

                data.products.forEach((product) => {
                    if (!product.variants[0]?.available) return;

                    const variantId = product.variants[0]?.id;
                    const productImg =
                    product.images[0]?.src ||
                    "//cdn.shopify.com/s/files/1/0000/0001/t/1/assets/no-image.png";

                    const cell = document.createElement("div");
                    cell.className = "carousel-cell";
                    cell.innerHTML = `
                    <input 
                        type="radio" 
                        id="${product.handle}" 
                        name="coffee" 
                        value="${variantId}" 
                        data-title="${product.title}"
                        class="bundle-product--radio"
                        data-variant-price="${product.variants[0]?.price || ''}" 
                        data-variant-compare-price="${product.variants[0]?.compare_at_price || ''}"
                        data-aeropress="${product.variants[0]?.id || ''}" 
                        data-whole-bean="${product.variants[1]?.id || ''}"
                    >
                    <label for="${product.handle}">
                        <img 
                        src="${productImg}&width=99&height=125&crop=center" 
                        width="99" 
                        height="125" 
                        loading="lazy" 
                        class="bundle-product--image"
                        >
                    </label>
                    `;

                    flkty.append(cell);

                    const radio = cell.querySelector("input[type=radio]");
                    if (selectedCoffee && radio) {
                        selectedCoffee.innerText = '';

                        radio.addEventListener("change", (e) => {
                            if (e.target.checked) {
                            selectedCoffee.innerText = `Select: ${e.target.dataset.title}`;

                            // Show/hide Aeropress checkbox
                            if (chkAeropress) {
                                if (e.target.dataset.aeropress && e.target.dataset.aeropress.trim() !== '') {
                                    chkAeropress.removeAttribute('hidden');
                                } 
                                else {
                                    chkAeropress.setAttribute('hidden', '');
                                }
                            }

                            // Show/hide Whole Bean checkbox
                            if (chkWholeBean) {
                                if (e.target.dataset.wholeBean && e.target.dataset.wholeBean.trim() !== '') {
                                    chkWholeBean.removeAttribute('hidden');
                                } 
                                else {
                                    chkWholeBean.setAttribute('hidden', '');
                                }
                            }
                            }
                        });
                    }
                });

                flkty.reloadCells();
                flkty.resize();
                document.querySelector('.flickity-next[data-carousel-target="carousel-coffee"]').removeAttribute('disabled');

                page++;
            })
            .catch((err) => {
                console.error("Error loading products:", err);
            })
            .finally(() => {
                loading = false;
            });
        }

        // When next arrow is clicked, check if we’re near the end
        const nextBtn = document.querySelector(`.flickity-next[data-carousel-target="carousel-coffee"]`);

        if (nextBtn) {
            nextBtn.addEventListener("click", function () {
                const lastVisible = flkty.selectedIndex + flkty.slides.length;
                const totalSlides = flkty.slides.length;

                // If user is at the last or second-to-last slide, load more
                if (flkty.selectedIndex >= totalSlides - 2) {
                    loadMoreProducts();
                }
            });
        }

        //Accessories
        function loadAccessoriesSplit(fetchUrl, carousels) {
            fetch(fetchUrl)
            .then((res) => res.json())
            .then((data) => {
            let products = data.products || [];
            if (!products || products.length === 0) return;

            carousels.forEach((config, index) => {
                const { carouselKey, selectedLabelId, inputName } = config;
                const carouselEl = document.querySelector(`[data-carousel="${carouselKey}"]`);
                if (!carouselEl) return;

                const flkty = instances[carouselKey];
                if (!flkty) return;

                // Clear old cells
                flkty.remove(flkty.getCellElements());

                // Filter logic
                let productsForCarousel = [];
                if (index === 0) {
                // First carousel: just load all
                productsForCarousel = products;
                } else {
                // Second carousel: exclude the selected one
                productsForCarousel = products.filter(
                    (p) => p.id != selectedAccessoryId
                );
                }

                // Append
                productsForCarousel.forEach((product) => {
                if (!product.variants[0]?.available) return;

                const variantId = product.variants[0]?.id;
                const productImg =
                    product.images[0]?.src ||
                    "//cdn.shopify.com/s/files/1/0000/0001/t/1/assets/no-image.png";

                const cell = document.createElement("div");
                cell.className = "carousel-cell";
                cell.innerHTML = `
                    <input 
                        type="radio" 
                        id="${product.handle}-${carouselKey}" 
                        name="${inputName}" 
                        value="${variantId}" 
                        data-title="${product.title}" 
                        data-product-id="${product.id}" 
                        data-product-handle="${product.handle}"
                        class="bundle-product--radio"
                        data-variant-price="${product.variants[0]?.price || ''}" 
                        data-variant-compare-price="${product.variants[0]?.compare_at_price || ''}"
                    >
                    <label for="${product.handle}-${carouselKey}">
                        <img 
                        src="${productImg}&width=99&height=125" 
                        width="99" 
                        height="125" 
                        loading="lazy" 
                        class="bundle-product--image"
                        >
                    </label>
                `;

                flkty.append(cell);
                });

                flkty.reloadCells();
                flkty.resize();
            });
            })
            .catch((err) => {
            console.error("Error loading collection:", err);
            });
        }
        
        function loadAccessoriesSplitFromProducts(products, carousels) {
            if (!products || products.length === 0) return;

            carousels.forEach((config) => {
                const { carouselKey, selectedLabelId, inputName } = config;
                const carouselEl = document.querySelector(`[data-carousel="${carouselKey}"]`);
                if (!carouselEl) return;

                const flkty = instances[carouselKey];
                if (!flkty) return;

                // Clear old cells
                const allCells = flkty.getCellElements();
                flkty.remove(allCells);

                // Render each product
                products.forEach((product) => {
                if (!product.variants[0]?.available) return;

                const variantId = product.variants[0]?.id;
                const productImg =
                    product.images[0]?.src ||
                    "//cdn.shopify.com/s/files/1/0000/0001/t/1/assets/no-image.png";

                const cell = document.createElement("div");
                cell.className = "carousel-cell";
                cell.innerHTML = `
                    <input 
                    type="radio" 
                    id="${product.handle}-${carouselKey}" 
                    name="${inputName}" 
                    value="${variantId}" 
                    data-title="${product.title}" 
                    data-product-id="${product.id}" 
                    data-product-handle="${product.handle}"
                    class="bundle-product--radio"
                    data-variant-price="${product.variants[0]?.price || ''}" 
                    data-variant-compare-price="${product.variants[0]?.compare_at_price || ''}"
                    >
                    <label for="${product.handle}-${carouselKey}">
                    <img 
                        src="${productImg}&width=99&height=125" 
                        width="99" 
                        height="125" 
                        loading="lazy" 
                        class="bundle-product--image"
                    >
                    </label>
                `;

                flkty.append(cell);

                // Preserve your label update logic
                const radio = cell.querySelector("input[type=radio]");
                if (selectedLabelId) {
                    const labelEl = document.getElementById(selectedLabelId);
                    if (labelEl) {
                    labelEl.innerText = "";
                    radio.addEventListener("change", (e) => {
                        if (e.target.checked) {
                        labelEl.innerText = `Select: ${e.target.dataset.title}`;
                        }
                    });
                    }
                }
                });

                flkty.reloadCells();
                flkty.resize();
                flkty.select(0, false, true);
            });
            }


        async function loadColors(colors, productHandle, productId) {
            colorSwatchesContainer.innerHTML = '';
            const productVariants = await getProductVariants(productHandle);

            selectedColor.innerText = '';
   
            colors.forEach((color, index) => {
                const colorName = color.name.charAt(0).toUpperCase() + color.name.slice(1);
                const matchingVariant = productVariants.find(variant =>
                    variant.options.includes(colorName)
                );   
                if(matchingVariant) {
                    if(index === 0) {
                        selectedColor.innerText = `Select: ${colorName}`;
                    }
                    if(index === 0 && matchingVariant.featured_image) {
                        //mainProductImage.src = matchingVariant.featured_image;
                        let defaultImage = matchingVariant.featured_image;
                        if (!defaultImage.includes("width=")) {
                            defaultImage = `${defaultImage}&width=600&height=600&crop=center`;
                        }
                        mainProductImage.src = defaultImage;
                    }
                    const cell = document.createElement("div");
                    cell.className = "product_option color";
                    cell.innerHTML = `
                    <input 
                        type="radio" 
                        id="${matchingVariant?.id || productId}" 
                        name="color" 
                        value="${matchingVariant?.id || productId}"
                        class="bundle-product--radio"
                        data-name="${colorName}"
                        data-variant-id="${matchingVariant?.id || ''}" 
                        data-variant-image="${matchingVariant?.featured_image || ''}"
                        data-variant-price="${matchingVariant?.price || ''}" 
                        data-variant-compare-price="${matchingVariant?.compare_at_price || ''}"
                        ${index === 0 ? "checked" : ""}
                    >
                    <label for="${matchingVariant?.id || productId}">
                        <span class="color-swatch__item" 
                        style="background-color: ${color.color};"></span>
                    </label>
                    `;
                    colorSwatchesContainer.append(cell);

                    const radio = cell.querySelector("input[type=radio]");
                    radio.addEventListener("change", (e) => {
                        if (e.target.checked) {
                            let newImage = e.target.dataset.variantImage;
                            const colorName = e.target.dataset.name;

                            selectedColor.innerText = `Select: ${colorName}`;
                            if (newImage) {
                                // Add Shopify resizing params for performance
                                if (!newImage.includes("width=")) {
                                    newImage = `${newImage}&width=600&height=600&crop=center`;
                                }

                                // Preload the new image
                                const img = new Image();
                                img.src = newImage;

                                img.onload = () => {
                                    // Crossfade effect
                                    mainProductImage.style.opacity = "0";

                                    setTimeout(() => {
                                    mainProductImage.src = newImage;
                                    mainProductImage.style.opacity = "1";
                                    }, 200); // 200ms fade duration
                                };
                            }
                        }
                    });

                }
            });        
        }

        function getAccessoriesCollection(productId) {
            const item = accessories_collections.find(obj => obj[productId]);
            return item ? item[productId] : null;
        }

        function getNovelId(productId) {
            const item = novel_ids.find(obj => obj[productId]);
            return item ? item[productId] : null;
        }

        function getSelectedCoffeeMaker() {
            const coffeeMakers = document.querySelectorAll('input[name="coffee-maker"]');

            coffeeMakers.forEach((coffeeMaker) => {
                coffeeMaker.addEventListener("change", function () {
                    const productHandle = this.dataset.productHandle;
                    const productId = this.dataset.productId;
                    const productTitle = this.dataset.title;
                    const productShortTitle = this.dataset.shortTitle;
                    const productDesc = this.dataset.description;
                    const productImage = this.dataset.mainImage;
                    const accessoriesCollection = getAccessoriesCollection(productId);
                    const novelJourneyId = getNovelId(productId);                    
                    const section = this.closest("collapsible-content");
                    const stampedStars = section.querySelector('.stamped-main-badge.stamped-stars-only');
                    const stampedCount = section.querySelector('.stamped-main-badge.stamped-count-only');
                    const stampedAverage = section.querySelector('.stamped-reviews_average');

                    closePanels();

                    if(productTitle || productShortTitle && selectedCoffeeMaker) {
                        selectedCoffeeMaker.innerText = `Select: ${productShortTitle || productTitle}`;
                    }

                    if(productDesc && selectedCoffeeMakerDesc) {
                        selectedCoffeeMakerDesc.innerText = `${productDesc}`;
                    }

                    if(accessoriesCollection !== null) {    
                        currentAccessoriesCollection = accessoriesCollection;
                        loadAccessoriesSplit(
                        `/collections/${accessoriesCollection}/products.json`, 
                        [
                            {carouselKey: "carousel-accessory", selectedLabelId: "selectedAccessory_1", inputName: "accessory_1"},
                            {carouselKey: "carousel-accessory-2", selectedLabelId: "selectedAccessory_2", inputName: "accessory_2"}
                        ]
                        );
                    }

                    if(productHandle) {
                        getProductColors(productHandle).then((colors) => {
                            if (colors.length) {
                                colorPanel.removeAttribute('hidden');
                                titleAccessory_1.innerText = '3. Add Accessory';
                                titleAccessory_2.innerText = '4. Add Another Accessory';
                                titleCoffee.innerText = '5. Add Coffee';
                                loadColors(colors, productHandle, productId);
                                confirmCoffeeMaker.dataset.hasColor = true;
                            } 
                            else {
                                colorPanel.setAttribute('hidden', '');
                                titleAccessory_1.innerText = '2. Add Accessory';
                                titleAccessory_2.innerText = '3. Add Another Accessory';
                                titleCoffee.innerText = '4. Add Coffee';
                                loadColors(colors, productHandle, productId);

                                let newImage = productImage;

                                if (newImage) {
                                    // Add Shopify resizing params for performance
                                    if (!newImage.includes("width=")) {
                                        newImage = `${newImage}&width=600&height=600&crop=center`;
                                    }

                                    // Preload the new image
                                    const img = new Image();
                                    img.src = newImage;

                                    img.onload = () => {
                                        // Crossfade effect
                                        mainProductImage.style.opacity = "0";

                                        setTimeout(() => {
                                        mainProductImage.src = newImage;
                                        mainProductImage.style.opacity = "1";
                                        }, 200); // 200ms fade duration
                                    };
                                }
                                confirmCoffeeMaker.dataset.hasColor = false;
                            }
                        });
                    }

                    loadNovelWidget(novelJourneyId);                   

                    stampedStars.dataset.id = productId;
                    stampedStars.dataset.productSku = productHandle;
                    stampedStars.dataset.productTitle = productTitle;

                    stampedCount.dataset.id = productId;
                    stampedCount.dataset.productSku = productHandle;
                    stampedCount.dataset.productTitle = productTitle;

                    stampedAverage.innerText = this.dataset.stampedAverage;

                    if (window.StampedFn && typeof window.StampedFn.loadBadges === "function") {
                        window.StampedFn.loadBadges();
                    }

                    stampedMainWidget.setAttribute("data-product-id", productId);
                    stampedMainWidget.setAttribute("data-name", productTitle);
                    stampedMainWidget.setAttribute("data-url", `${shopUrl}/products/${productHandle}`);
                    stampedMainWidget.setAttribute("data-image-url", productImage);
                    stampedMainWidget.setAttribute("data-description", productDesc);
                    stampedMainWidget.setAttribute("data-product-sku", productHandle);

                    if (window.StampedFn) {
                        window.StampedFn.reloadUGC();
                    }
                });
            });
        }

        function getSelectedColor() {
            const colorItems = document.querySelectorAll('input[name="color"]');

            colorItems.forEach((color) => {
                color.addEventListener("change", function (e) {
                    if (e.target.checked) {
                        let newImage = e.target.dataset.variantImage;
                        const colorName = e.target.dataset.name;

                        selectedColor.innerText = `Select: ${colorName}`;
                        if (newImage) {
                            if (!newImage.includes("width=")) {
                                newImage = `${newImage}&width=600&height=600&crop=center`;
                            }

                            // Preload the new image
                            const img = new Image();
                            img.src = newImage;

                            img.onload = () => {
                                // Crossfade effect
                                mainProductImage.style.opacity = "0";

                                setTimeout(() => {
                                mainProductImage.src = newImage;
                                mainProductImage.style.opacity = "1";
                                }, 200); // 200ms fade duration
                            };
                        }
                    }
                });
            });
        }

        function getSelectedCoffee() {
            const coffeeItems = document.querySelectorAll('input[name="coffee"]');

            coffeeItems.forEach((coffee) => {
                coffee.addEventListener("change", function () {
                    const productTitle = this.dataset.title;
                    const productDesc = this.dataset.description;
                    const aeropressVariantId = this.dataset.aeropress;
                    const wholeBeanVariantId = this.dataset.wholeBean;

                    if(productTitle && selectedCoffeeMaker) {
                        selectedCoffee.innerText = `Select: ${productTitle}`;
                    }

                    /* if(productDesc && selectedCoffeeDesc) {
                        selectedCoffeeDesc.innerText = `${productDesc}`;
                    } */

                    if(aeropressVariantId) {
                        radAeropress.value = aeropressVariantId;
                    }

                    if(wholeBeanVariantId) {
                        radWholeBean.value = wholeBeanVariantId;
                    }
                });
            });
        }

        function getSelectedAccessory(radio, textSelected) {
            const accessories = document.querySelectorAll(radio);

            accessories.forEach((accessory) => {
                accessory.addEventListener("change", function () {
                    const productTitle = this.dataset.title;
                    //const productDesc = this.dataset.description;

                    if(productTitle && textSelected) {
                        textSelected.innerText = `Select: ${productTitle}`;
                    }

                    /* if(productDesc && selectedCoffeeMakerDesc) {
                        selectedCoffeeDesc.innerText = `${productDesc}`;
                    } */
                });
            });
        }


        function renderSecondCarousel() {
            if (!currentAccessoriesCollection) return; // nothing selected yet

            fetch(`/collections/${currentAccessoriesCollection}/products.json`)
            .then((res) => res.json())
            .then((data) => {
            let products = data.products || [];

            if (!products || products.length === 0) return;

            // 🚩 Filter out the product already picked in accessory_1
            if (selectedAccessoryId) {
                products = products.filter(
                (p) => String(p.id) !== String(selectedAccessoryId)
                );
            }

            // Now load only into carousel 2
            loadAccessoriesSplitFromProducts(products, [
                {
                carouselKey: "carousel-accessory-2",
                selectedLabelId: "selectedAccessory_2",
                inputName: "accessory_2",
                },
            ]);
            })
            .catch((err) => console.error("Error filtering accessories:", err));
        }


        getSelectedCoffeeMaker();
        getSelectedColor();
        getSelectedCoffee();
        //getSelectedAccessory('input[name="accessory_1"]', selectedAccessory_1);
        //getSelectedAccessory('input[name="accessory_2"]', selectedAccessory_2);
        if (first_product && stampedMainWidget) {
            initStampedMainWidget(stampedMainWidget);
        }
        document.addEventListener("change", (e) => {
            if (e.target.name === "accessory_1") {
                selectedAccessoryId = e.target.dataset.productId;
                console.log(`selectedAccessoryId: ${selectedAccessoryId}`);
                console.log(`currentAccessoriesCollection: ${currentAccessoriesCollection}`);
                updateSelectedTitle("accessory_1", "selectedAccessory_1");

                // Re-render the second carousel after selection
                renderSecondCarousel();
            }

            if (e.target.name === "accessory_2") {
                // update label for second accessory
                updateSelectedTitle("accessory_2", "selectedAccessory_2");
            }
        });
    });

    loadNovelWidget(currentNovelId);

    /* Helper Functions */

    removeButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const key = btn.getAttribute("data-btn-remove");

            if (key in bundleObj) {
                bundleObj[key] = null;
                notyf.success(`${key.replace(/_/g, " ")} has been removed from the bundle.`);
            } 
            else {
                notyf.success(`${key.replace(/_/g, " ")} does not exist in the bundle.`);
            }
            
            updateSummary();
            updateSkipButtons();
        });
    });

    skipButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const key = btn.getAttribute("data-btn-skip");
            const container = btn.closest(".collapsible-container");

            if (!container) return;

            const toggle = container.querySelector(".collapsible-toggle");
            const content = container.querySelector("collapsible-content");

            if (toggle) {
            toggle.setAttribute("aria-expanded", "false");
            }
            if (content) {
            content.removeAttribute("open");
            }
        });
    });

    function updateSkipButtons() {
        skipButtons.forEach((btn) => {
            const key = btn.getAttribute("data-btn-skip");

            if (bundleObj[key]) {
            btn.disabled = true; // disable if value exists
            btn.classList.add("is-disabled"); // optional styling hook
            } else {
            btn.disabled = false; // enable if no value
            btn.classList.remove("is-disabled");
            }
        });
    }

    async function addBundleToCart(bundleObj, discountCode = null) {
        const items = [];

        if (!bundleObj.coffeeMaker?.id) {
            console.error("Coffee Maker is required to add a bundle.");
            return; // stop function if missing
        }

        // --- Coffee Maker ---
        const coffeeMakerVariantId = bundleObj.color?.id
            ? bundleObj.color.id   // use color variant if available
            : bundleObj.coffeeMaker.id; // fallback to base coffee maker id

        items.push({
            id: coffeeMakerVariantId,
            quantity: 1,
        });

        // --- Accessories ---
        Object.keys(bundleObj).forEach((key) => {
            if (key.startsWith("accessory") && bundleObj[key]?.id) {
            items.push({
                id: bundleObj[key].id,
                quantity: 1,
            });
            }
        });

        // --- Coffee ---
        if (bundleObj.coffee?.id) {
            items.push({
            id: bundleObj.coffee.id,
            quantity: 1,
            });
        }
        // --- Nothing selected ---
        if (!items.length) {
            notyf.success("No items to add.");
            return;
        }

        // --- Send to Shopify Cart API ---
        try {
            const res = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items }),
            });

            const data = await res.json();

            if(discountCode) {
                 console.log(`applying discount...`)
                fetch("/cart/update.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ discount: discountCode }),
                })
                .then(res => res.json())
                .then(console.log)
            }

            return data;
        } catch (err) {
            console.error("Error adding bundle:", err);
        }
    }

    function formatPrice(price, comparePrice) {
        if (comparePrice && comparePrice !== "") {
            return `
            <span class="price-compare" style="text-decoration: line-through; margin-right: 0.5em;">
                ${comparePrice}
            </span>
            <span class="price-current">${price}</span>
            `;
        }
        return price || "";
    }

    function updateBundleProgress(bundleObj) {
        const progressBar = document.querySelector('#bundleProgress .progress-bar__fill');
        if (!progressBar) return;

        // count how many bundleObj keys have a value
        const keys = ["coffeeMaker", "color", "accessory_1", "accessory_2", "coffee"];
        const filledCount = keys.reduce((count, key) => bundleObj[key] ? count + 1 : count, 0);

        const total = keys.length;
        const percent = (filledCount / total) * 100;

        progressBar.style.width = `${percent}%`;
    }

    if (window.innerWidth < 999) {
        if (!mobileSection || !stickyAtcButton) return;

        // Intersection Observer callback
        const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    mobileSection.style.display = "none";
                    bundleProgress.classList.remove('sticky');
                } 
                else {
                    mobileSection.style.display = "flex";
                    bundleProgress.classList.add('sticky');
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, {
            root: null,       // viewport
            threshold: 0.1    // trigger when at least 10% of the button is visible
        });

        observer.observe(stickyAtcButton);
    }   

    function initStampedMainWidget(widget) {
        widget.setAttribute("data-product-id", first_product.productId);
        widget.setAttribute("data-name", first_product.productTitle);
        widget.setAttribute("data-url", `${shopUrl}/products/${first_product.productHandle}`);
        widget.setAttribute("data-image-url", first_product.productImage);
        widget.setAttribute("data-product-sku", first_product.productHandle);

        if (window.StampedFn) {
            window.StampedFn.reloadUGC();
        }
    }

    function closePanels() {
        document.querySelectorAll('.section-bundle-builder .collapsible-container:not([data-name="summary"]):not([data-name="coffee-maker"])').forEach((panel) => {
            panel.querySelector('.collapsible-toggle').setAttribute('aria-expanded','false');
            panel.querySelector('collapsible-content').removeAttribute('open');
        });
    }

    function updateSelectedTitle(inputName, labelId) {
        const checked = document.querySelector(`input[name="${inputName}"]:checked`);
        if (checked) {
            const selectedLabel = document.getElementById(labelId);
            if (selectedLabel) {
            selectedLabel.textContent = checked.dataset.title;
            }
        }
    }

    async function loadNovelWidget(journeyId) {
        const loadEmbedScript = (release) => {
            window[`prefetchedJourneyRelease_${journeyId}`] = release

            const script = document.createElement('script');
            script.setAttribute('src', embedJsUrl);
            script.setAttribute('journey-id', journeyId);
            script.setAttribute('async', '');
            if(script) {
                embedElem.innerHTML = '';
                embedElem.appendChild(script);
            }
        };

        const response = await fetch(
        `${apiBaseUrl}/api/v2/journeys/${journeyId}/releases?type=PUBLISH&sort=createdAt&order=DESC&size=1`,
        )
        const releases = await response?.json();

        if (
        releases?.length &&
        releases[0].isPublished &&
        releases[0].embedConfigs[0]?.embedType?.uniqueName?.toLowerCase() === OVERLAY_EMBED_TYPE_UNIQUE_NAME
        ) {
            const handleScroll = () => {
                if (document.documentElement.scrollTop >= 25) {
                loadEmbedScript(releases[0])
                window.removeEventListener('scroll', handleScroll);
                }
            }
            window.addEventListener('scroll', handleScroll);
        } 
        else {
            const options = {
                root: null,
                rootMargin: '300px',
                threshold: 0,
            }
            const observer = new IntersectionObserver((entries, observer) => {
                if (entries) {
                for (const entry of entries) {
                    if (entry.target.id === embedSectionId && entry.isIntersecting) {
                    observer.unobserve(entry.target)
                    loadEmbedScript(releases[0])
                    break
                    }
                }
                }
            }, options)
            observer.observe(embedElem)
        }
    }

});